import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFetch } from "utils/hooks";

import { useQuery } from "@tanstack/react-query";

import { Urls } from "../../urls.ts";

import { AvailableSlotApiResponse } from "./type.ts";

export const MORNING_HOURS_CONSTANT = "12:00";
export const AFTER_HOURS_CONSTANT = "18:00";

type useAvailableSlotsParams = {
  date?: string | null;
  hallId?: string | null;
};

const useAvailableSlots = (params: useAvailableSlotsParams) => {
  const { date, hallId } = params;

  const fetch = useFetch();

  const { data, isFetching, isError } = useQuery<
    AvailableSlotApiResponse | null,
    Error,
    AvailableSlotApiResponse
  >({
    queryKey: ["available-slots", date],
    enabled: !!(date && hallId),
    queryFn: () =>
      fetch<AvailableSlotApiResponse>(`${Urls.AvailableSlots}?date=${date}`, {
        method: "GET",
        slug: {
          hallId,
        },
      }),
    gcTime: 0,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      toast.error("Error getting booking");
    }
  }, [isError]);

  return {
    slots: data?.availableSlots || [],
    isFetching,
  };
};

export default useAvailableSlots;
